'use strict';

exports.__esModule = true;
exports.transformSeletedLocation = exports.transformDropdownLocation = exports.transformDropdownLanguage = exports.transformDropdownInsurer = exports.transformDropdownSpecialties = exports.sortMobileResults = exports.transformDropdownTreatmentGroups = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _uniqBy = require('lodash/uniqBy');

var _uniqBy2 = _interopRequireDefault(_uniqBy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transformDropdownTreatmentGroups = exports.transformDropdownTreatmentGroups = function transformDropdownTreatmentGroups() {
  var treatmentGroups = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var type = arguments[1];

  var result = [];
  treatmentGroups.forEach(function (group) {
    if (group.treatments) {
      result.push({
        id: group.id,
        name: group.name,
        icon_uri: '',
        sort_order: 1,
        type: 'section-header',
        isSectionHeader: true
      });
      group.treatments.forEach(function (treatment) {
        return result.push({
          id: treatment.id,
          name: treatment.name,
          type: type || treatment.keyword_type,
          icon_uri: treatment.icon_uri,
          sort_order: treatment.sort_order
        });
      });
    }
  });
  return result;
};

var sortMobileResults = exports.sortMobileResults = function sortMobileResults(results) {
  return results.sort(function (a, b) {
    if (a.type === 'specialty' && b.type !== 'specialty') {
      return -1;
    }
    if (a.type === 'specialty' && b.type === 'specialty') {
      return 0;
    }
    if (a.type !== 'specialty' && b.type !== 'specialty') {
      return 0;
    }
    if (a.type !== 'specialty' && b.type === 'specialty') {
      return 1;
    }
  });
};

var transformDropdownSpecialties = function transformDropdownSpecialties() {
  var specialties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var requiredTopLevelSpecialtiesNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var topLevelSpecialtiesHeader = {
    name: 'Common Specialties',
    isSectionHeader: true
  };
  var relatedSpecialtiesHeader = {
    name: 'Specialties',
    isSectionHeader: true
  };

  var topLevelSpecialties = specialties.filter(function (specialty) {
    return specialty.parent_name === 'abstract_top_level_keyword';
  });

  if (requiredTopLevelSpecialtiesNames.length > 0) {
    topLevelSpecialties = requiredTopLevelSpecialtiesNames.map(function (name) {
      return specialties.find(function (item) {
        return item.name === name;
      });
    }).filter(Boolean);
  } else {
    topLevelSpecialties = specialties.filter(function (specialty) {
      return specialty.sort_order >= 0;
    });
  }

  topLevelSpecialties = topLevelSpecialties.map(function (_ref) {
    var children = _ref.children,
        rest = (0, _objectWithoutProperties3.default)(_ref, ['children']);
    return (0, _extends3.default)({}, rest, {
      children: children ? children.filter(function (item) {
        return item.keyword_type === 'specialty';
      }) : undefined
    });
  });

  var relatedSpecialties = (0, _uniqBy2.default)(specialties.filter(function (specialty) {
    return specialty.parent_name !== 'abstract_top_level_keyword' && specialty.keyword_type === 'specialty';
  }).reduce(function (accumulator, subSpecialty) {
    var relatedParent = topLevelSpecialties.find(function (topLvlSpecialty) {
      return topLvlSpecialty.id === subSpecialty.parent_id;
    });

    if (relatedParent) {
      accumulator.push(subSpecialty);
    }

    return accumulator;
  }, []), 'id');

  return Array.prototype.concat(topLevelSpecialtiesHeader, topLevelSpecialties, relatedSpecialtiesHeader, relatedSpecialties);
};

exports.transformDropdownSpecialties = transformDropdownSpecialties;
var transformDropdownInsurer = exports.transformDropdownInsurer = function transformDropdownInsurer() {
  var insurers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  return insurers.map(function (insurer) {
    insurer.iconUri = insurer.icon_uri && process.env.PROXY_HOST + ':' + process.env.PROXY_PORT + '/' + insurer.icon_uri;
    return insurer;
  });
};

var transformDropdownLanguage = exports.transformDropdownLanguage = function transformDropdownLanguage() {
  var languages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return languages.filter(function (language) {
    return language.is_visible_from_website;
  });
};

var transformDropdownLocation = exports.transformDropdownLocation = function transformDropdownLocation() {
  var locations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return locations.map(function (location) {
    return {
      name: location.description,
      placeId: location.place_id
    };
  });
};

var transformSeletedLocation = exports.transformSeletedLocation = function transformSeletedLocation() {
  var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return {
    name: location.formatted_address,
    value: {
      lng: location.geometry.location.lng(),
      lat: location.geometry.location.lat()
    }
  };
};


// WEBPACK FOOTER //
// ./components/global-components/lib/transformers/dropdowns.js